import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {PhotoGuideSetting, PhotoGuideSettingSchema} from './types';

// The Photo Guide is stored as the `sales-photo-guide` General Setting, so it shares the
// 'GeneralSettingsTenant' tag with the generic setting hooks. Saving it also reshapes the guide
// layouts of sale vehicle albums on the backend, so cached album photos are refetched.
const PHOTO_GUIDE_SETTING_ID = 'sales-photo-guide';
const PHOTO_GUIDE_URL = '/dms/v1/sales/photo-guide';

export const photoGuideApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getPhotoGuideSetting: build.query<PhotoGuideSetting, void>({
      query: () => ({url: PHOTO_GUIDE_URL}),
      providesTags: [{type: 'GeneralSettingsTenant', id: PHOTO_GUIDE_SETTING_ID}],
      extraOptions: {responseSchema: PhotoGuideSettingSchema},
    }),
    updatePhotoGuideSetting: build.mutation<void, PhotoGuideSetting>({
      query: (body) => ({url: PHOTO_GUIDE_URL, method: 'PUT', body}),
      // A failed save must not refetch the guide: the remount would drop the unsaved draft.
      invalidatesTags: invalidateOnSuccess([
        {type: 'GeneralSettingsTenant', id: PHOTO_GUIDE_SETTING_ID},
        'SaleVehicleAlbumPhotos',
      ]),
    }),
  }),
});

export const {useGetPhotoGuideSettingQuery, useUpdatePhotoGuideSettingMutation} = photoGuideApi;
